module.exports = __webpack_public_path__ + "img/DAVID_CANNON_45-rs.f0bef5d0.jpg";